import { useState } from 'react';

import ContractsListElectricity from './ContractsListElectricity';
import ContractsListGas from './ContractsListGas';
import { useSettingsContext } from '../Settings/hooks/useSettingsContext';

import { Tabs, Tab, Box, Typography, Stack, colors, Paper } from '@mui/material';
import GasIcon from '../../assets/GasIcon';
import LightIcon from '../../assets/LightIcon';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from "react-router";
import { ContractDisplayTypes } from './types/contracts';

interface ContractsTabProps {
  initContractType: ContractDisplayTypes
}

const ContractsTabs = ({initContractType}: ContractsTabProps) => {
  const Settings = useSettingsContext();
  const features = Settings.features;
  const { t } = useTranslation();
  const [searchParams, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [contractType, setContractType] = useState(initContractType);

  const handleChangeContractType = (_event: React.SyntheticEvent, value: ContractDisplayTypes) => {
    setContractType(value);
    navigate(t(`common:url.contracts.${value}.default`) + "?" + searchParams.toString());
  };

  return <Stack spacing={3}>

    <Stack spacing={1}>
      <Typography variant='h4'>
        {t('common:text.contracts_list_title')}
      </Typography>
      <Typography variant='subtitle1'>
        {t('common:text.contracts_list_subtitle')}
      </Typography>
    </Stack>

    {features.displayTypes.length > 1 ? 
      <Stack>
        <Stack direction="row">
          <Tabs 
            value={contractType} 
            onChange={handleChangeContractType}
            sx={{borderBottom: `1px solid ${colors.grey[300]}`}}
          >
            {features.displayTypes.includes('electricity') && 
              <Tab 
                label={t("common:text.contracts_tab_title_electricty")} 
                value="electricity" 
                icon={<LightIcon />} 
                iconPosition="start"
                sx={{minHeight: 0}}
              />
            }

            {features.displayTypes.includes('gas') && 
              <Tab 
                label={t("common:text.contracts_tab_title_gas")} 
                value="gas" 
                icon={<GasIcon />} 
                iconPosition="start"
                sx={{minHeight: 0}}
              />
            }
          </Tabs>
        </Stack>
        <Box pt={2}>
          {features.displayTypes.includes('electricity') && 
            <div hidden={contractType !== 'electricity'}>
              <ContractsListElectricity/>
            </div>
          }
          {features.displayTypes.includes('gas') && 
            <div hidden={contractType !== 'gas'}>
              <ContractsListGas/>
            </div>
          }
        </Box>
      </Stack>
    : 
      <>
        {features.displayTypes[0] === 'electricity' && 
          <ContractsListElectricity/>
        }
        {features.displayTypes[0] === 'gas' && 
          <ContractsListGas/>
        }
      </>
    }

  </Stack>;
}

export default ContractsTabs;